import { useCallback } from 'react'
import { useLocation, useParams } from 'router-v6'
import { ErrorBoundary } from 'v2/shared/components/error-boundary'
import { ScenariosPanel } from './scenarios-panel'
import { SimulationsPanel } from './simulations-panel'
import { useAppNavigate } from 'v2/shared/hooks/use-app-navigate'

export const SimulationTab = () => {
  const { id = '' } = useParams()
  const location = useLocation()
  const navigate = useAppNavigate()

  const basePath = `/agent/builder/${id}/simulation`
  const viewingResults = location.pathname.includes('/simulation/results')

  const handleRunStarted = useCallback(
    (runUuid: string) => {
      navigate(`${basePath}/results/${runUuid}`)
    },
    [basePath, navigate],
  )

  const navigateToResults = useCallback(() => {
    navigate(`${basePath}/results`)
  }, [basePath, navigate])

  const navigateToScenarios = useCallback(() => {
    navigate(basePath)
  }, [basePath, navigate])

  return (
    <div className="flex flex-col h-full">
      {viewingResults ? (
        <ErrorBoundary>
          <SimulationsPanel onBack={navigateToScenarios} />
        </ErrorBoundary>
      ) : (
        <ErrorBoundary>
          <ScenariosPanel onRunStarted={handleRunStarted} onViewBatchResults={navigateToResults} />
        </ErrorBoundary>
      )}
    </div>
  )
}
